import React from 'react';
import { Link } from 'gatsby';

import Layout from '../components/Layout';
import Footer from '../components/Footer';
import Social from '../components/Social';

const PrivacyPolicy = () => (
  <Layout>
    <section className="cta">
      <div className="cta-content">
        <div className="container">
          <h2>
            Privacy Policy
            <br />
            <Link className="btn btn-outline btn-xl" to="/">
              Go back
            </Link>
          </h2>
        </div>
      </div>
      <div className="overlay"></div>
    </section>
    <section className="privacy" id="privacy">
      <div className="container">
        <div className="section-heading text-center">
          <h1>Samfunns-Statsborgerpøve Privacy Policy</h1>
          <p>
            <em>Last Edited on 2025-07-10</em>
          </p>
          <hr />
        </div>
        <div className="container-fluid text-muted">
          <p>
            Applies to <strong>"Samfunnsprøve Citizenship test"</strong> application.<br />
            Android -{' '}
            <a href="https://play.google.com/store/apps/details?id=com.samfunnstest.app" target="_blank" rel="noopener noreferrer">
              https://play.google.com/store/apps/details?id=com.samfunnstest.app
            </a>
            <br />
            iOS -{' '}
            <a href="https://apps.apple.com/no/app/samfunnspr%C3%B8ve-citizenship-test/id1527153572" target="_blank" rel="noopener noreferrer">
              https://apps.apple.com/no/app/samfunnspr%C3%B8ve-citizenship-test/id1527153572
            </a>
          </p>
          <p>
            This privacy policy has been compiled to better serve those who are
            concerned with how their ‘Personally Identifiable Information’ (PII)
            is being used online. PII, as described in US privacy law and
            information security, is information that can be used on its own or
            with other information to identify, contact, or locate a single
            person, or to identify an individual in context. Please read our
            privacy policy carefully to get a clear understanding of how we
            collect, use, protect or otherwise handle your Personally
            Identifiable Information in accordance with our website.
          </p>
          <p>
            <b>
              What personal information do we collect from the people who use
              our app?
            </b>
          </p>

          <p>
            Email address is collected when a user sends emails to &nbsp;
            <a href="mailto:samfunnsprove@gmail.com">
              samfunnsprove@gmail.com
            </a>
          </p>

          <p>
            <b>How do we use your information?</b>
          </p>
          <ul>
            We may use the information we collect from you in the following
            ways:
            <li>
              To improve our website or application in order to better serve
              you.
            </li>
            <li>
              To allow us to better service you in responding to your customer
              service requests.
            </li>
            <li>To follow up application bug or crash investigation.</li>
          </ul>
          <p>
            <strong>Third-party disclosure</strong>
            <br />
            We do not sell, trade, or otherwise transfer to outside parties your
            Personally Identifiable Information or other Personal Information
            entered into our app.
          </p>
          <p>
            <strong>Third-party links</strong>
            <br />
            Occasionally, at our discretion, we may include or offer third-party
            products or services on our website. These third-party sites have
            separate and independent privacy policies. We therefore have no
            responsibility or liability for the content and activities of these
            linked sites. Nonetheless, we seek to protect the integrity of our
            site and welcome any feedback about these sites.
          </p>
          <p>
            <strong>California Online Privacy Protection Act</strong>
            <br />
            CalOPPA is the first state law in the nation to require commercial
            websites and online services to post a privacy policy. The law’s
            reach stretches well beyond California to require any person or
            company in the United States (and conceivably the world) that
            operates websites collecting Personally Identifiable Information
            from California consumers to post a conspicuous privacy policy on
            its website stating exactly the information being collected and
            those individuals or companies with whom it is being shared. – See
            more at:&nbsp;
            <a href="https://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf" target="_blank" rel="noreferrer noopener">
              https://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf
              <br />
            </a>
            <br />
            According to CalOPPA, we agree to the following:
            <br />
            Users can visit our site anonymously.
            <br />
            Once this privacy policy is created, we will add a link to it on our
            home page or as a minimum, on the first significant page after
            entering our website.
            <br />
            Our Privacy Policy link includes the word ‘Privacy’ and can easily
            be found on the page specified above.
          </p>

          <p>
            You will be notified of any Privacy Policy changes On our Privacy
            Policy Page
          </p>

          <p>
            <strong>How does our site handle Do Not Track signals?</strong>
            <br />
            We honor Do Not Track signals and Do Not Track, plant cookies, or
            use advertising when a Do Not Track (DNT) browser mechanism is in
            place.
          </p>

          <p>
            <strong>
              Does our site allow third-party behavioral tracking?
            </strong>
            <br />
            It’s also important to note that we allow third-party behavioral
            tracking
          </p>

          <p>
            <strong>COPPA (Children Online Privacy Protection Act)</strong>
            <br />
            When it comes to the collection of personal information from
            children under the age of 13 years old, the Children’s Online
            Privacy Protection Act (COPPA) puts parents in control. The Federal
            Trade Commission, United States’ consumer protection agency,
            enforces the COPPA Rule, which spells out what operators of websites
            and online services must do to protect children’s privacy and safety
            online.
          </p>
          <p>
            We do not specifically market to children under the age of 13 years
            old.
          </p>

          <p>
            <strong>Amendments to Privacy Policy</strong>
            <br />
            We have the right to amend this Privacy Policy at any time, without
            prior notice to each User. Any changes we may make to our Privacy
            Policy in the future will be posted here. Where appropriate, we will
            notify you or seek your consent. Please check back frequently to see
            any updates or changes to our Privacy Policy.
          </p>

          <p>
            <strong>Contact info</strong>
            <br />
            If at any time you would like to contact us with your views about
            our privacy practices, or with any enquiry relating to your Personal
            Data (its correction, removal or use), you can do so by sending a
            letter to our email address:{' '}
            <a href="mailto:samfunnsprove@gmail.com">
              samfunnsprove@gmail.com
            </a>
            .
          </p>
        </div>
      </div>
    </section>

    <section className="contact bg-primary" id="contact">
      <div className="container">
        <h2>
          We appreciate your feedback &nbsp;
          <i className="fas fa-heart"></i>
        </h2>
        <Social />
      </div>
    </section>

    <Footer />
  </Layout>
);

export default PrivacyPolicy;
